import React, { useState } from "react";
import jlptData from "../../data/jlptVideos.json";

const JlptVideoCard = ({ video }) => {
  const [play, setPlay] = useState(false);

  return (
    <div className="jlpt-video-card">
      {!play ? (
        <div
          className="video-thumbnail"
          role="button"
          tabIndex={0}
          onClick={() => setPlay(true)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") setPlay(true);
          }}
        >
          <img
            src={`https://img.youtube.com/vi/${video.videoId}/hqdefault.jpg`}
            alt={video.title}
          />
          <span className="play-btn">▶</span>
        </div>
      ) : (
        <div className="video-frame">
          <iframe
            src={`https://www.youtube.com/embed/${video.videoId}?autoplay=1`}
            title={video.title}
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </div>
      )}

      <div className="jlpt-video-info">
        <h4>{video.title}</h4>
        <a
          href={video.watchUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="jlpt-video-link"
        >
          <i className="fa fa-youtube-play" aria-hidden="true" /> Watch on YouTube
        </a>
      </div>
    </div>
  );
};

const JlptLevelRow = ({ level }) => (
  <div className="jlpt-level-row">
    <h4 className="jlpt-level-title">{level.level}</h4>
    <div className="jlpt-videos-grid">
      {level.videos.map((video) => (
        <JlptVideoCard key={video.id} video={video} />
      ))}
    </div>
  </div>
);

const JlptVideos = () => {
  return (
    <>
      <div className="section-header">
        <h3 className="highlighted-text">JLPT Prep Videos</h3>
        <p className="section-description">
          Follow our JLPT N5 &amp; N4 lessons on YouTube
        </p>
      </div>
      <section className="jlpt-videos-section review-container">
        {jlptData.levels.map((level) => (
          <JlptLevelRow key={level.id} level={level} />
        ))}
      </section>
    </>
  );
};

export default JlptVideos;
